// Maps the /scan API report into the shape the UI renders.
// Tolerates older report shapes (string opportunities, single-action roadmap phases).

const num = (val, fallback = 0) => {
  const n = Number(val);
  return Number.isFinite(n) ? n : fallback;
};

const arr = (val) => (Array.isArray(val) ? val : []);

const PHASE_DEFAULTS = [
  { timeframe: "0–3 months", title: "Foundation & quick wins" },
  { timeframe: "3–6 months", title: "Integrate & scale" },
  { timeframe: "6–12 months", title: "Advanced AI deployment" }
];

export const mapAIReport = (raw) => {
  if (!raw) return null;
  const data = raw.report ? raw.report : raw;

  return {
    score: num(data.score),
    score_breakdown: {
      data_maturity: num(data.score_breakdown?.data_maturity),
      automation: num(data.score_breakdown?.automation),
      ai_readiness: num(data.score_breakdown?.ai_readiness),
      digital_adoption: num(data.score_breakdown?.digital_adoption)
    },
    industry_benchmark: {
      industry_avg_score: num(data.industry_benchmark?.industry_avg_score, 50),
      top_quartile_score: num(data.industry_benchmark?.top_quartile_score, 75),
      position: data.industry_benchmark?.position || "Competitive",
      commentary: data.industry_benchmark?.commentary || ""
    },
    maturity_level: data.maturity_level || "Developing",
    lead_score: data.lead_score || "warm",
    cost_reduction_percent: num(data.cost_reduction_percent),
    revenue_uplift_percent: num(data.revenue_uplift_percent),
    roi: num(data.roi),
    payback_months: num(data.payback_months),

    opportunities: arr(data.opportunities).map((o, i) => {
      if (typeof o === "string") {
        return { id: i + 1, title: o.length > 80 ? o.slice(0, 80) + "…" : o, description: o.length > 80 ? o : "" };
      }
      return {
        id: i + 1,
        title: o.title || "",
        description: o.description || "",
        category: o.category || "",
        impact: o.impact || "",
        effort: o.effort || "",
        estimated_annual_value: num(o.estimated_annual_value)
      };
    }).filter(o => o.title),

    quick_wins: arr(data.quick_wins).filter(Boolean),

    roadmap: arr(data.roadmap).map((p, i) => ({
      id: i + 1,
      phase: p?.phase || `Phase ${i + 1}`,
      timeframe: p?.timeframe || PHASE_DEFAULTS[i]?.timeframe || "",
      title: p?.title || PHASE_DEFAULTS[i]?.title || "",
      actions: arr(p?.actions).length ? arr(p.actions) : (p?.action ? [p.action] : [])
    })),

    risks: arr(data.risks)
      .map(r => (typeof r === "string" ? { risk: r, mitigation: "" } : r))
      .filter(r => r?.risk),
    kpis: arr(data.kpis).filter(Boolean),
    summary: data.summary || "",
    is_fallback: Boolean(data.is_fallback)
  };
};

export const formatINR = (value) => {
  const n = Number(value) || 0;
  if (n >= 1e7) return `₹${(n / 1e7).toFixed(n >= 1e8 ? 0 : 1)} Cr`;
  if (n >= 1e5) return `₹${(n / 1e5).toFixed(n >= 1e6 ? 0 : 1)} L`;
  return `₹${n.toLocaleString("en-IN")}`;
};
